export const ATTENDANCE_STATUS = {
  NOT_CHECKED: "notChecked",
  PARTIALLY_CANCELLED: "partiallyCancelled",
  CANCELLED: "cancelled",
  CHECKED: "checked",
};

const cancellationStatuses = ["cancelledOnTime", "cancelledLate"];

const getCancelledStudentIds = students => new Set(
  students
    .filter(student => cancellationStatuses.includes(student.participationStatus))
    .map(student => student.id),
);

const getParticipantIds = (scheduledLesson = {}) => {
  const defaultStudents = scheduledLesson.defaultStudents || [];
  const registerStudents = (scheduledLesson.lessonRegister && scheduledLesson.lessonRegister.students) || [];
  const ids = [
    ...defaultStudents.map(student => student.id),
    ...registerStudents.map(student => student.id),
  ].filter(Boolean);

  return [...new Set(ids)];
};

const hasRegisterForAllParticipants = (scheduledLesson = {}) => {
  const participantIds = getParticipantIds(scheduledLesson);
  if (participantIds.length === 0) return true;

  const registerStudents = (scheduledLesson.lessonRegister && scheduledLesson.lessonRegister.students) || [];
  if (registerStudents.length === 0) return true;

  const registerStudentIds = new Set(registerStudents.map(student => student.id).filter(Boolean));

  return participantIds.every(studentId => registerStudentIds.has(studentId));
};

export function getLessonAttendanceStatus(scheduledLesson = {}) {
  const { lessonRegister } = scheduledLesson;
  if (!lessonRegister) return ATTENDANCE_STATUS.NOT_CHECKED;

  const details = lessonRegister.lessonDetails || {};
  if (details.lessonStatus === "cancelled") return ATTENDANCE_STATUS.CANCELLED;
  if (details.attendanceStatus === ATTENDANCE_STATUS.CHECKED && !hasRegisterForAllParticipants(scheduledLesson)) {
    return ATTENDANCE_STATUS.NOT_CHECKED;
  }
  if (details.attendanceStatus) return details.attendanceStatus;

  const students = lessonRegister.students || [];
  const hasCancellation = students.some(student => cancellationStatuses.includes(student.participationStatus));
  if (hasCancellation) return ATTENDANCE_STATUS.PARTIALLY_CANCELLED;

  return students.length > 0 ? ATTENDANCE_STATUS.CHECKED : ATTENDANCE_STATUS.NOT_CHECKED;
}

export function isAttendanceChecked(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.CHECKED;
}

export function isLessonCancelled(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.CANCELLED;
}

export function hasPartialCancellation(scheduledLesson) {
  return getLessonAttendanceStatus(scheduledLesson) === ATTENDANCE_STATUS.PARTIALLY_CANCELLED;
}

export function hasAllParticipantsCancelled(scheduledLesson = {}) {
  if (isLessonCancelled(scheduledLesson)) return true;

  const { lessonRegister } = scheduledLesson;
  if (!lessonRegister) return false;

  const participantIds = getParticipantIds(scheduledLesson);
  if (participantIds.length === 0) return false;

  const cancelledStudentIds = getCancelledStudentIds(lessonRegister.students || []);
  return participantIds.every(studentId => cancelledStudentIds.has(studentId));
}
